import React, { FC } from 'react';
import { FormInput } from '../merchants/FormInput';
import { COMMENT_FORM_FIELD, COMMENT_FORM_FIELD_NAME } from '../../constants/comment/comment-form';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { InputType } from '../form/form-input-constants';
import { useTranslation } from 'react-i18next';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';


interface Props {
  formik: any;
  additionalClass: string;
}

export const SettlementsComments: FC<Props> = (props) => {
  const { formik, additionalClass } = props;

  const { t } = useTranslation();
  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

  const publicComment = (
    <FormInput
      formik={formik}
      key={COMMENT_FORM_FIELD.COMMENT}
      fieldName={COMMENT_FORM_FIELD.COMMENT}
      label={checkRoles(authUser, CLAIMS.MERCHANT_ADMIN)
        ? t(COMMENT_FORM_FIELD_NAME.COMMENT)
        : t(COMMENT_FORM_FIELD_NAME.PUBLIC_COMMENT)}
      placeholder={t(COMMENT_FORM_FIELD_NAME.COMMENT_PLACEHOLDER)}
      inputType={InputType.Description}
      isEditMode={true}
      additionalClasses="col-12 col-sm-12 col-md-12"
      descriptionFieldHeight={80}
      disabled
      readOnly
    />
  );

  const internalComment = (
    <>
      {
        checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN) && (
          <FormInput
            formik={formik}
            key={COMMENT_FORM_FIELD.INTERNAL_COMMENT}
            fieldName={COMMENT_FORM_FIELD.INTERNAL_COMMENT}
            label={t(COMMENT_FORM_FIELD_NAME.INTERNAL_COMMENT)}
            placeholder={t(COMMENT_FORM_FIELD_NAME.COMMENT_PLACEHOLDER)}
            inputType={InputType.Description}
            isEditMode={true}
            additionalClasses="col-12 col-sm-12 col-md-12"
            descriptionFieldHeight={80}
            disabled
            readOnly
          />
        )
      }
    </>
  );

  return (
    <div className={additionalClass}>
      {publicComment}
      {internalComment}
    </div>
  );
};